import { render, staticRenderFns } from "./client-information.vue?vue&type=template&id=e8d74932&scoped=true"
import script from "./client-information.vue?vue&type=script&lang=js"
export * from "./client-information.vue?vue&type=script&lang=js"
import style0 from "./client-information.vue?vue&type=style&index=0&id=e8d74932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d74932",
  null
  
)

export default component.exports